import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CampApi } from '../api/camp.api';
import { CampMst, CampData } from '../../../interfaces/masters/camp';

@Injectable()
export class CampService extends CampData{

  constructor(private api: CampApi) {
    super();
   }

  list(url: string): Observable<CampMst[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<CampMst>{
      return this.api.getById(url);
  }

  create(url: string, data:any): Observable<any[]> {
    return this.api.add(url,data);
  }
  searchList(url: string,data:any): Observable<any> {
    return this.api.searchList(url,data);
  }
  update(url: string, data:CampMst): Observable<CampMst> {
    return this.api.update(url,data);
  }

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
